import {deleteJson, getJson, postJson, patchJson} from '@/util/ajaxUtils';
import {OPEN_APP_INFO_HEADERS} from '@/api/openAjaxUtils';

export function sendBatchJourneies() {
    return getJson(`/open/sendBatchJourneies`, {
        headers: OPEN_APP_INFO_HEADERS,
    });
}

export function sendJourneies(keywords) {
    return getJson(`/open/sendJourneies/${keywords}`);
}
